<script>
    import HeaderHome from "../components/HeaderHome.svelte";
    import { _ } from "../services/i18n";

    // Componentes de UI
    import ButtonGroup from "../components/ButtonGroup.svelte";
    import TableView from "../components/TableView.svelte";
    import { getModels, getArticleParts, getAccessoryTypes, getAccessories } from "../services/models";
    import {  getPrice, formatShoppingCartData, getDBLines, saveDBLines } from "../services/shoppingCart";
    import { getMaterials } from "../services/materials";
    import { onMount } from "svelte";
    import { formatPrice } from '../services/orders'
    import { loadLibraryDictionary, libTranslate } from '../services/libraryDictionary'
    import { getLibraryData } from "../services/fetchData";

    export let addItemId;

    // Props para el TableView de líneas
    $: items = getDBLines() || [];
    let articles = [];
    let columns = {}
    let lockItemsRow;
    let unlockItemsRow;
    let isItemsLocked;
    let editItem;
    let itemAccept;
    let itemCancel;
    let itemsChanged;
    let priceAvailable;
    let fieldName = $_('orderEdit_uphold');
    let totalPriceString = "";
    const onItemChanged = async (data) => {
        const articleData = items.find(i => i === data.item);
        let libraryItem = null;
        if (articleData && data.fieldName === "article") {
            libraryItem = data.searchData.find(i => i.article === data.newValue);
            data.item.name = libraryItem?.name || data.newValue;
        }
        if (articleData && data.fieldName === "units") {
            data.item.units = data.newValue;
        }

        if (data.fieldName === "article") {
            setTimeout(async () => {
                const newItem = items[items.length - 1];
                if (newItem.article) {
                    // Cargar información de telas y accesorios
                    if (newItem.materials.length === 0) {
                        const parts = await getArticleParts(newItem.article);
                        newItem.materials = parts;
                    }

                    if (newItem.accessories.length === 0) {
                        const accessories = await getAccessoryTypes(newItem.article);
                        newItem.accessories = accessories;
                    }


                    setUpholstery(newItem);
                }
            }, 100);
        }
        else if (data.fieldName === "units") {
            await updatePrice();
        }
        saveDBLines(items);
    }
    const onAddItemPressed = async () => {
        if (!items.find(({article}) => article === "")) {
            items = [...items, {
                drawableUUID: crypto.randomUUID(),
                article: "",
                name: "",
                units: 1,
                price: 0,
                materials: [],
                accessories: []
            }]
        }
        saveDBLines(items);
    }

    async function updatePrice() {
        const cartData = await getPrice(formatShoppingCartData(items));
        if (cartData) {
            let totalPrice = 0;
            items.forEach(item => {
                const scItem = cartData.data.find(i => i.drawableUUID === item.drawableUUID);
                item.price = scItem.price;
                totalPrice += item.price.finalPrice;
                item.lineReport = scItem.lineReport;
                item.realIdentifier = scItem.realIdentifier;
                item.finalPrice = formatPrice(item.price.finalPrice, cartData.rate);
            });
            items = items;
            await saveDBLines(items);

            priceAvailable = totalPrice != 0;
            totalPriceString = formatPrice(totalPrice, cartData.rate);
        }
    }

    let detailMode = "";
    const setUpholstery = async (item, reloadParts = false) => {
        if (item.materials.length === 0 && reloadParts) {
            const parts = await getArticleParts(item.article);
            item.materials = parts;
        }

        if (item.materials?.length > 0) {
            lockItemsRow(item)
            detailMode = "uphold";
            await saveDBLines(items);
        }
        else {
            detailMode = "";
            await saveDBLines(items);
            await setAccessories(item);
        }
    }
    const setAccessories = async (item) => {
        // if (item.accessories.length === 0 && reloadAccessories) {
        //    const accessories = await getAccessoryTypes(item.article);
        //    item.accessories = accessories;
        // }

        if (item.accessories?.length) {
            lockItemsRow(item);
            detailMode = "accessory"
            await saveDBLines(items);
        }
        else {
            detailMode = "";
            await saveDBLines(items);
            
            // Calculamos el precio
            await saveAccessories();
        }
    }
    const removeItem = async (item) => {
        items = items.filter(i => i !== item);
        await updatePrice();
        await saveDBLines(items);
    }

    onMount(async () => {
        await loadLibraryDictionary();
        articles = (await getModels()).map(({ article, name, model }) => ({ article, name, model }));
        columns = {
            "Artículo": {
                type: "string",
                editable: true,
                fieldName: "article",
                dataSourceCallback: async (item) => (await getModels()).map(({ article, name, model, thumbnail, have3D }) => {
                    return { article, name, model, thumbnail, have3D }
                }),
                dataSourceKey: "article",
                dataSourceVisibleFields: ["article", "name", "model"]
            },
            "Título": {
                type: "string",
                editable: false,
                fieldName: "name"
            },
            "Unidades": {
                type: "stepper",
                editable: true,
                fieldName: "units",
                min: 0.01
            },
            "Acciones": {
                type: "actions",
                actions: {
                    edit: { callback: setUpholstery, icon: "icons/texture-box.svg", isEnabled: (item) => item.materials?.length },
                    blockEdit: { callback: setAccessories, icon: "icons/cog.svg", isEnabled: (item) => item.accessories?.length },
                    delete: { callback: removeItem, icon: "icons/delete.svg" }
                }
            },
            "Precio": {
                type: "html",
                editable: false,
                fieldName: "finalPrice"
            }
        }

        if (addItemId) {
            let item = articles.find(art => art.article === addItemId);
            if (item) {
                items = [...items, {
                    drawableUUID: crypto.randomUUID(),
                    article: item.article,
                    name: item.name,
                    units: 1,
                    price: 0,
                    materials: [],
                    accessories: []
                }];
            }
            await saveDBLines(items);

            // Carga la información de partes tapizables y abre la interfaz para
            // seleccionar la tela
            await setUpholstery(items[items.length-1], true);

            // Carga la información e accesorios
            const accessories = await getAccessoryTypes(items[items.length-1].article);
            items[items.length-1].accessories = accessories;

            // En las funciones saveAccessories y cancelAccessories se restaura
            // el hash de la URL para eliminar el parámetro add/:addItemId
        }
        else {
            // Esto se hace para generar el precio de los elementos que ya estén cargados
            await updatePrice();
        }
    })

    async function saveUpholstery(evt) {
        const item = editItem;
        
        unlockItemsRow();
        detailMode = "";

        await saveDBLines(items);

        await setAccessories(item);
        //if (!item.accessories?.length) {
        //    await updatePrice();
        //    if (addItemId) {
        //        location.hash = '#/orderEdit';
        //    }
        //}
    }

    async function saveAccessories(evt) {
        unlockItemsRow();
        detailMode = "";

        await updatePrice();

        await saveDBLines(items);

        // Si se acaba de añadir un elemento como parámetro de URL, al terminar de añadir el elemento, actualizar el hash:
        if (addItemId) {
            location.hash = "#/orderEdit"
        }
    }

    let saveMaterialsAction;
    let saveAccessoriesAction;

    let searchHoverImage = null;
    function onSearchItemHover(evt) {
        searchHoverImage = evt.detail;
    }

    let materialsLibraryUrl = "";
    async function getMaterialsLibraryUrl() {
        if (!materialsLibraryUrl) {
            materialsLibraryUrl = (await getLibraryData('materials')).resourcesUrl;
        }
        return materialsLibraryUrl;
    }

    async function onSearchFabricHover(evt) {
        const url = `${ await getMaterialsLibraryUrl() }/${evt.detail?.item?.thumbnail}`;
        searchHoverImage = {
            item: {
                thumbnail: url,
                name: evt.detail.item.name
            },
            clientX: evt.detail.clientX,
            clientY: evt.detail.clientY
        };
    }

    function onSearchItemOut() {
        searchHoverImage = null;
    }

</script>

<main>
    {#if searchHoverImage?.item?.thumbnail}
        <div class="search-hover-image" style="top: {searchHoverImage.clientY + 10}px; left: {searchHoverImage.clientX + 10}px">
            <img src={searchHoverImage.item.thumbnail} alt={searchHoverImage.item.name} />
        </div>
    {/if}
    <HeaderHome />
    <h3>{$_('orderEdit_title')}</h3>
    <div class="order-items">
        <TableView
            bind:data={items}
            bind:columns={columns}
            on:change={async evt => {
                await updatePrice();
                await saveDBLines(items);
            }}
            bind:lockEditRow={lockItemsRow}
            bind:unlockEditRow={unlockItemsRow}
            bind:isLocked={isItemsLocked}
            bind:editItem={editItem}
            bind:accept={itemAccept}
            bind:cancel={itemCancel}
            bind:dataChanged={itemsChanged}
            on:itemChanged={evt => onItemChanged(evt.detail)}
            on:itemCancel={async () => await saveDBLines(items)}
            on:addItem={async evt => await onAddItemPressed()}
            on:searchItemHover={evt => onSearchItemHover(evt)}
            on:searchItemOut={evt => onSearchItemOut()}
            showButtons={false}
            addButton={true}
            />    
    </div>
    <!--
    <ButtonGroup
        actions={{
            "ui_buttons_accept": () => itemAccept()
        }}
        disabled={{
            "ui_buttons_accept": itemsChanged === false || editItem !== null
        }} />
    -->
    
    <div class="detail-view">
        {#if editItem && detailMode === "uphold"}
           <div class="titles-options"> <img src="icons/step_1.jpg" alt=""> <h3>{$_('orderEdit_uphold')}</h3></div>
            <TableView 
                bind:data={editItem.materials}
                columns={{
                    "PARTE TAPIZABLE" : {
                        type: "string",
                        editable: false,
                        fieldName: "part"
                    },
                    "NOMBRE DE PARTE": {
                        type: "string",
                        editable: false,
                        fieldName: "partName"
                    },
                    "TELA": {
                        type: "string",
                        editable: true,
                        fieldName: "fabric",
                        dataSourceCallback: async (item) => {
                            const materials = await getMaterials();
                            return materials.filter(mat => mat.type === "material" ).map(mat => {
                                return {
                                    // TODO: Traducción de nombre
                                    name: mat.id,
                                    description: mat.name,
                                    serie: mat.metadata?.serie,
                                    type: "",
                                    thumbnail: mat.icon
                                }
                            })
                        },
                        dataSourceKey: "name",
                        dataSourceVisibleFields: ["name", "description", "serie"]
                    },
                    "DESCRIPCIÓN": {
                        type: "string",
                        editable: false,
                        fieldName: "description"
                    },
                    "SERIE": {
                        type: "string",
                        editable: false,
                        fieldName: "serie"
                    },
                    "TIPO": {
                        type: "string",
                        editable: false,
                        fieldName: "type"
                    },
                    "ACCIÓN": {
                        type: "actions",
                        actions: {
                            applyAll: { callback: item => {
                                editItem.materials.forEach(otherItem => {
                                    otherItem.fabric = item.fabric
                                    otherItem.description = item.description;
                                    otherItem.serie = item.serie;
                                    otherItem.type = item.type;
                                });
                                editItem.materials = editItem.materials;
                            }, icon: "icons/duplicate-texture.svg"},
                            delete: { callback: item => {
                                item.fabric = "";
                                item.description = "";
                                item.serie = "";
                                item.type = "";
                                editItem.materials = editItem.materials;
                            }, icon: "icons/delete.svg" }
                        }
                    }
                }}
                on:change={saveUpholstery}
                on:itemChanged={(evt) => {
                    const { newValue, item, searchData } = evt.detail
                    const searchItem = searchData?.find(searchItem => searchItem.name === newValue)
                    if (searchItem) {
                        item.description = searchItem.description;
                        item.serie = searchItem.serie;
                        item.type = searchItem.type;
                    }
                }}
                on:searchItemHover={evt => onSearchFabricHover(evt)}
                on:searchItemOut={evt => onSearchItemOut()}
                bind:accept={saveMaterialsAction}
                showButtons={false}
                clearOnCancel={false}
                />
            <ButtonGroup
                actions={{
                    "ui_buttons_accept": () => saveMaterialsAction()
                }} />
        {:else if editItem && detailMode === "accessory"}
        <div class="titles-options"><img src="icons/step_2.jpg" alt="">  <h3>{$_('orderEdit_accessories')}</h3></div>
            <TableView 
                bind:data={editItem.accessories}
                columns={{
                    "Tipo": {
                        type: "string",
                        editable: false,
                        fieldName: "type"
                    },
                    "Nombre Tipo": {
                        type: "string",
                        editable: false,
                        fieldName: "typeName"
                    },
                    "Accesorio": {
                        type: "string",
                        editable: true,
                        fieldName: "accessory",
                        dataSourceCallback: async (item) => {
                            const accessories = await getAccessories(editItem.article);
                            return accessories
                                .filter(accData => accData.type === item.type)
                                .map(accData => ({
                                    name: accData.id,
                                    description: libTranslate(accData.id, accData.name)
                                }));
                        },
                        dataSourceKey: "name"
                    },
                    "Nombre Accesorio": {
                        type: "string",
                        editable: false,
                        fieldName: "accessoryName"
                    },
                    "Unidades": {
                        type: "stepper",
                        editable: true,
                        fieldName: "units"
                    }
                }}
                on:change={saveAccessories}
                on:itemChanged={evt => {
                    const { newValue, item, searchData, fieldName } = evt.detail;
                    if (fieldName === 'accessory') {
                        const searchItem = searchData?.find(searchItem => searchItem.name === newValue)
                        if (searchItem) {
                            item.accessory = searchItem.name;
                            item.accessoryName = libTranslate(searchItem.name, searchItem.description)
                        }
                    }
                    else if (fieldName === "units") {
                        // No se hace nada
                    }
                }}
                bind:accept={saveAccessoriesAction}
                showButtons={false}
                />
            <ButtonGroup
                actions={{
                    "ui_buttons_accept": () => saveAccessoriesAction()
                }} />
        {:else}
            <section>
                {#if priceAvailable }                    
                    <header>
                        <h2 id="price">{$_("orderEdit_totalPrice")}: <strong>{@html totalPriceString}</strong></h2>
                        <a href="/sim3d.html?cartOnly=true#/compositor/summary" class="btn-3d third">{$_("nav_shoppingCart_process")}</a>
                    </header>
                {:else}
                    <header>
                        
                    </header>
                {/if}
            </section>
        {/if}
    </div>    

</main>

<style>

    main {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        text-transform: capitalize;
    }
    .order-items {
        /*height: 40vh;*/
        width: 100%;
        
    }

    .detail-view {
        height: 30vh;
        width: 100%;
    }

    #price {
        margin: 15px 0;

    }

    h3 {
        margin: 20px 0;
        color: #1b3258;
        font-weight: 400;

    }

    .titles-options {
       display: inline-flex;

    }
 
    .search-hover-image {
        position: fixed;
        width: 100px;
        height: 100px;
        background-color: white;
        border: 1px solid black;
        box-shadow: 0 0 5px rgb(0 0 0 / 50%);
        z-index: 1000;
        border-radius: 8px;
        pointer-events: none;
        overflow: hidden;
    }

    .search-hover-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>